import { render } from "./DocumentManager.vue?vue&type=template&id=836f5c20"
import script from "./DocumentManager.vue?vue&type=script&lang=js"
export * from "./DocumentManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__